<template>
  <div class="container">
    <div class="news-detail">
      <div class="nd-body">
        <div class="bread-nav">
          <span @click="navgoTo()">全部</span> > 职场资讯 >
          <span class="txt-gray">{{objData.title}}</span>
        </div>
        <div class="nd-body-content">
          <div class="nd-body-view">
            <div class="nd-body-view-title">{{objData.title}}</div>
            <div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 职场资讯</div>
            <div class="nd-body-view-content">{{objData.content}}</div>
            <p>但是，这种努力真的能够感动领导吗？</p>
            <div class="nd-body-view-content">
              <img src="../../../static/Bitmap_2.jpg" alt="map" />
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
              <div>{{objData.contenta}}</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
              <div>{{objData.contentb1}}</div>
              <!-- <div>{{objData.contentb2}}</div>
              <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
              <div>{{objData.contentc1}}</div>
              <!-- <div>{{objData.contentc2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlee}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlef}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleg}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-of">
              <div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
              <div>下一篇：{{objData.next}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowNewsDetail",
  data() {
    return {
      id: "",
      objData: {
        title: `一个35岁的职场老鸟给你提个醒：千万不要试图去感动你的领导`,
        date: `2019年9月19日`,
        froms: `播聘`,
        next: `播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
        prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
        content: `职场上，有这么一类人，他们每天埋头苦干，加班加点，时不时还在朋友圈晒个周末加班的图片，为的就是让领导看到自己的努力状态，让领导感动，进而给自己升职加薪。`,
        subtitle: `天天加班，努力工作，却在一年后被辞退`,
        contenta: `晓敏在一家新媒体公司负责文案策划工作，天天加班加点，是努力的典型。
早晨第一来到办公室，不仅把办公室打扫的干干净净，还不忘给领导打壶热水；
下午5点半下班，她肯定要等到领导走了以后再走，即使没有任务了，也在办公室坐着“学习”；
如果任务来了，大家都在加班，办公室内5个人，晓敏肯定最后一个走，还不忘发一个半夜加班的朋友圈……
看晓敏的工作状态，大家肯定被她努力的样子感动了，但是，奇怪的是，一年以后她却被公司辞退了。
为什么，她的直属领导说，她虽然努力，我们也看在眼里，非常感动。
但是，她实在是对公司没有任何价值，加班的文案不仅与单位发展不配套，而且有时候还出现这样那样的错字。她在单位已经工作一年了，现在拿出的方案跟去年相比，没有任何进步。
我们之所以留她在这里一年，就是看看她能不能在一年之内，能够有所改变，但是很遗憾，她也只是单纯的很努力而已，没有任何价值。
所以，公司上下一致认为，辞退晓敏是正确的选择，毕竟，我们这里不是慈善机构。
`,
        // contenta1: `4G改变生活，5G改变社会。播聘平台顺应5G的时代趋势而生。作为目前唯一的大数据视频招聘生活社交服务平台，播聘全心致力于“让天下没有难招的工，没有失业的人”的伟大事业。目前国内业务主要集中在全国一线城市及各个省会城市，未来还会扩展至全球数十个重要的地区和国家。`,
        // contenta2: `与传统招聘平台不同的是，播聘结合大数据、云计算、用户画像等技术开创的视频简历与视频面试的生活新方式，是人工智能时代对招工方式的一次颠覆与创新。`,

        subtitleb: `努力工作，会让老板感动吗？`,
        contentb1: `你去烤鸡店买只烤鸡，只会在乎烤鸡好不好吃。你会在乎烤鸡店的老板为了做好这只烤鸡的过程有多艰辛吗？
同样是烤鸡，他却要那么辛苦，你只会觉得他太无能。
你在老板眼中的重要程度不在于你有多努力，你为公司付出了多少汗水，而在于你有多少使用价值，你有多少不可替代性！
不要想着让老板感动，感动是廉价而且被动的。因为努力不是优点，努力只是你的过程，自己默默体会就好了。
高效能的创造出优质的成果才是一个员工的优点。
`,
        // contentb2: `另一方面，企业不仅可以在播聘平台上发布岗位要求和招工信息，还可以上传视频到平台以呈现公司的企业文化、工作环境、工作氛围等，有助于求职者直观、全面地了解企业，吸引志同道合的伙伴，同时增加企业关注度和影响力。`,
        // contentb3: `对求职者来说，播聘平台倡导“秀出真我”，求职者通过视频简历可以直观地展现工作技能、兴趣爱好、个人性格，有效突破文字简历的平面性和局限性，同时提高个人简历的吸引力和价值。`,
        // contentb4: `播聘平台通过系统数据分析求职者的求职意向，精准推送与之匹配的岗位，企业在看过求职者的视频简历后，即可在线视频面试，不仅大幅度降低求职者的时间成本，而且提升了求职成功率。`,

        subtitlec: `老板要用人赚钱，而不是花钱看苦情戏`,
        contentc1: `以前在知乎上看到过这样一个故事：
某公司，办公室四个人。
甲月薪一万，每天上班迟到，下班早退，老板从来不批评他，总是笑脸相迎；
乙月薪一万，上班不是嗑瓜子，补妆，刷娱乐新闻是经常的，偶尔老板交代点事情还很不愿意的推三阻四；
丙月薪一万，老板不打电话让来上班那就几乎看不到人；
丁一本大学毕业，上班总是比所有人早到，打扫卫生、开窗户、整理一天准备干的活，晚上最后一个走无条件加班，总结一天的工作报给老板，关电关水关门，月薪4000。
某日，工商税务的执法人员发现该公司税务上有点问题，遂要求检查，于是老板叫来甲，小甲啊，晚上约你舅舅一起吃个饭呗。
又某日，客户因为质量问题停止了对该公司的货款，老板又叫来乙，小乙啊，下午约你姐夫喝个茶呗，好久没跟他聊天了。
再某日，老板把小丙叫办公室来，小丙啊，听说你大伯调到市政府当秘书长了，来来来，我们是大学同学，他上次说想喝点家乡的茶，这个茶叶你看什么时候帮我捎过去给他一下。
又某日，老板叫来丁，小丁，你这报表怎么做的，几个数据都填错，昨天晚上又忘了关空调吧，让你打电话催一下客户财务的呢？催了没有？货款什么时候到？你这个工作态度，你拿什么让我给你涨工资？唉，你们现在的年轻人，稍微吃点苦就觉得干了很大事情，稍微加点班就要加班费、你这样我很担心你的前途啊……
虽然这个故事有点偏激，但也在一定程度上反应了一个道理“老板要用人赚钱，而不是花钱看苦情戏”
`,

        subtitled: `老板只认“功劳”不认“苦劳”，没有成果的努力，不但不会被感动，反而会被鄙视`,
        contentd1: `你的努力就是“苦劳”，而你创造的价值成果，才是你的“功劳”，一字之差，意义却完全不同。
对老板来说，只会认你的功劳，不会认你的“苦劳”。
柳井正在《经营者成长笔记》中写道：“企业的每个人都是经营者，而一个合格的经营者，就是实现自己承诺，取得成果的人，否则，无效的努力没有任何意义”。
比如，老板让你做一个活动策划案，你在办公室熬了一个通宵，第二天一早就交给领导。
结果领导一看，方案根本没法用，不仅不贴合实际，而且错字连篇。
看着你的熊猫眼，老板也许会说辛苦了，快点休息会。
但老板心里想的一定是：“这个人水平太差了，加班通宵，就弄出来这么个低档次的玩意儿！”
你认为在升职加薪的时候，老板会想到你吗？
因为老板和公司想要的是一份高逼格的活动方案，不是你带来的两个黑眼圈和一脸可怜相。
`,
        // contentd2: `雪莱在《西风颂》中曾说过：如果冬天来了，春天还会远吗？在“经济寒冬”的浪潮下，播聘将搭建起企业和求职者沟通的桥梁，让企业和求职者各取所需、共同发展，为中国的人力资源行业贡献一份力，为中国经济创造新奇迹增添一份彩！`
        subtitlee: `有句话叫屁股决定脑袋，老板考虑问题的层次跟你是不一样的`,
        contentd1: `文明一点的说法，叫做“位置决定想法”。一个人坐什么位置，往往决定了他思考的角度和范围。
作为一名员工，为企业付出那么多，自然希望能够感动老板，得到该有的回报。这个很容易理解。
作为一名老板，我们有自己的情感，自然会被那些为我卖命的员工感动，但是，一到涉及到实际利益的时候，我们就会有很多考虑。
做老板，我当然可以被你感动，只要你不要我为这份感动买单，我可以一天感动好几次，每次都感动出高潮。
但是，你要我为这份感动买单，对不起，我得先想想。
如果你想通过感动我，然后来获取更多的东西，那我也会先衡量你能给我带来多少利益，你为我创造的利益是不是能大于我给你的支出。
因为，升职加薪，牵涉到了企业的支出和收益。直白地告诉大家，老板们想的都是用最小的支出获取最大的利润！能不花钱，就不花钱，能少花钱，就少花钱。

`,
        subtitlef: `没有核心竞争力的感动，都是施舍`,
        contentd1: `不要想着仅凭努力工作，去感动老板。感动了老板又怎样，你自身没有核心价值，核心竞争力，累死也捞不到多少实际好处。纯粹就是浪费自己的业余时间，损耗自己的身体。
努力，真的是件没有门槛的事情。只要想努力，很多人都能做到努力。
让自己拥有核心竞争力，才是最重要的。做好你的本职工作，留点时间给自己去学习、充电、提升吧。让自己拥有职业上的核心价值，这远比努力更能打动人心，更容易带来利益。只有这样子，你才不会成为企业往死里压榨的普通员工。
《资本论》里，有这样一句话：资本来到世间，从头到脚，每个毛孔都滴着血和肮脏的东西。
做生意，就是为了挣钱的，就是为了追求利益最大化的，就是榨取剩余价值的。
做生意，不是做慈善。他们在明面上，谈着奉献，实际上，只是想要员工在现有的薪酬上，付出更多免费的，义务的劳动，获取员工更多的剩余价值。
讲利益的地方，不要讲感情。不要老是做没有意义的加班，否则赔光了健康，赔掉了升值的时间，再无翻盘的机会。
`,
        subtitleg: `提升自己的职场身价，从远离幼稚病开始`,
        contentd1: `过分相信努力，本身就是一种幼稚病。
请不要再相信单一因素判断
这个世界从来不是单因素决定的，你要知道真实世界实在是复杂的多。
就像成为一个好的自媒体人，你不仅要懂内容、你还要懂运营，甚至于商务合作，品牌你都需要涉猎。
不需要你一个人把这些事干完，但是你要懂这些事，才能管理的好下面的人。
①换一个角度思考
当你站在老板的角度，你就知道老板是怎么想的了。
从招聘的角度，理解求职。
你会发现，面试官其实才是真正有压力的，他们担心找不到好的人才，以及看走眼招进来了不合适的人。
从公司高层的角度，理解晋升。
你会发现，他们其实要找的，不过是能力、潜力都强的人才，而你只需要在竞聘的时候证明这一点。
换一个角度思考，事情会容易很多。
②不要排斥与同行社交
当你开始成为团队主管、年龄超过30以后，你会发现很多时候你的精力已经有些跟不上更年轻的新人了。
这个时候，你在团队里发挥的更多是把握方向，排除风险，把控进度的价值。
如果说职场头10年，你需要更多通过作品来证明你的能力。
职场进入第10年以后，你也需要通过行业的认可，来放大你的价值，甚至于获得新的机会。

`
      }
    };
  },
  created(option) {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.id = _this.$route.query.id || ``;
    },
    navgoTo() {
      this.$nav({ path: `/show-news` }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./show-message.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-message/show-message.vue